module.exports = __webpack_public_path__ + "static/media/9DESA29.f649623a.jpg";